module.exports = __webpack_public_path__ + "static/media/boton-siregistrado.d5771345.svg";